import {
    Button,
    FormLabel,
    Grid,
    Paper,
    CircularProgress,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    InputAdornment,
    ClickAwayListener,
    InputLabel
} from '@material-ui/core';
import React, { useState, useContext, useEffect } from 'react';
import { SelectBox, TextBox } from '../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/styles';

import { getTCards_GetVehicles, TCards_GetExistingTCardsByRegNumber } from '../../../Core/Service/checkInRole';
import _ from 'lodash';
import AppContext from '../../../App/AppContext';

import SearchIcon from '@material-ui/icons/Search';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import { getDataByRegNo } from '../../../Core/Service/common-service';

const useStyles = makeStyles(() => ({
    button: {
        borderRadius: '8px',
        padding: '5px 16px',
        textTransform: 'none',
        color: '#fff',
        backgroundColor: '#1976d2',
        '&:hover': {
            backgroundColor: '#155a9d'
        }
    },
    dropdownContainer: {
        position: 'absolute',
        zIndex: 1000,
        width: '100%',
        maxHeight: '200px',
        overflowY: 'auto',
        marginTop: '2px',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
    },
    dropdownItem: {
        textAlign: 'left',
        padding: '8px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f5f5f5'
        }
    },
    highlightedItem: {
        backgroundColor: '#C24B3D',
        color: 'white',
        '&:hover': {
            backgroundColor: '#C24B3D'
        }
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'lightgrey',
        // color: theme.palette.common.white,
        padding: '5px',
        fontWeight: 800
    },
    body: {
        fontSize: 14,
        padding: '5px',
        fontWeight: 600
        // border: '1px solid rgba(0, 0, 0, 0.1)'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        cursor: 'pointer',
        background: '#f5f5f5',
        '&:hover': {
            backgroundColor: 'grey'
        }
        // '&:nth-of-type(odd)': {
        //     backgroundColor: theme.palette.action.hover
        // }
    }
}))(TableRow);

const SearchTcardByReg = ({ getRegValues, value, getReg, isLabelShrink, isError, isUpdate, ...props }) => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const [width, height] = useWindowSize();
    const classes = useStyles();

    const [state, setState] = useState({
        regNumberToSearch: value || '',
        cashAccountTypeCategoryID: null,
        categories: [],
        vehicleList: [],
        loading: false,
        selectedVehicle: {},
        vehicleMot: {}
    });

    const [isShow, setIsShow] = useState({ showJobPopup: false });
    const [showDropdown, setShowDropdown] = useState(false);

    useEffect(() => {
        if (value) {
            setState((prev) => ({ ...prev, regNumberToSearch: value }));
        }
    }, [value]);

    // API Call with Debounce
    const fetchVehicles = async () => {
        if (state.regNumberToSearch.length > 4) {
            setState((prev) => ({ ...prev, loading: true }));
            try {
                let res = await getTCards_GetVehicles(state.regNumberToSearch.trim().toUpperCase());
                const res2 = await getDataByRegNo(state.regNumberToSearch.trim().toUpperCase());
                setState((prev) => ({
                    ...prev,
                    vehicleList: res.data.tCards,
                    vehicleMot: res2.data?.mot || {},
                    loading: false
                }));
                if (res.data.tCards.length > 0) {
                    setShowDropdown(true);
                } else {
                    showToast('Vehicles not found!');
                    setShowDropdown(false);
                }
            } catch (error) {
                console.error('Error fetching vehicles:', error);
                setState((prev) => ({ ...prev, loading: false }));
            }
        } else {
            setShowDropdown(false);
            setState((prev) => ({
                ...prev,
                vehicleList: [],
                loading: false
            }));
        }
    };

    // const debouncedFetchVehicles = useCallback(_.debounce(fetchVehicles, 500), []);

    const fieldChange = (e) => {
        const { name, value } = e.target;
        const trimmedValue = value;
        getReg(trimmedValue);
        setState((prev) => ({ ...prev, [name]: trimmedValue }));
        // debouncedFetchVehicles(trimmedValue);
    };

    const handleVehicleSelect = (vehicle) => {
        try {
            getRegValues(vehicle, state.vehicleMot);

            setState((prev) => ({ ...prev, selectedVehicle: vehicle }));
            setShowDropdown(false);
        } catch (error) {
            console.error('Error selecting vehicle:', error);
        }
    };

    const handleAddPopUp = (name) => {
        setIsShow((prev) => ({ ...prev, [name]: true }));
    };

    const closeWarningModal = (isClose) => {
        setIsShow((prev) => ({ ...prev, showJobPopup: false }));
    };

    const modalTitleRender = () => {
        return (
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>Customer: {state.selectedVehicle.customer}</Grid>
                <Grid item>Reg No: {state.selectedVehicle.reg}</Grid>
            </Grid>
        );
    };

    return (
        <Grid item xs={12} style={{ position: 'relative' }}>
            <InputLabel error={isError ? true : false} shrink={isLabelShrink ? true : false}>
                {' '}
                Registration Number
            </InputLabel>
            <TextBox
                autoFocus
                name="regNumberToSearch"
                onChange={fieldChange}
                onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                        fetchVehicles();
                    }
                }}
                value={state.regNumberToSearch}
                InputProps={{
                    endAdornment: !isUpdate && (
                        <InputAdornment position="start">
                            {state.loading ? (
                                <CircularProgress size={24} style={{ position: 'absolute', right: 20 }} />
                            ) : (
                                <SearchIcon style={{ cursor: 'pointer' }} onClick={fetchVehicles} />
                            )}{' '}
                        </InputAdornment>
                    )
                }}
                {...props}
            />

            {showDropdown && state.vehicleList.length > 0 && (
                <ClickAwayListener onClickAway={() => setShowDropdown(false)}>
                    <div style={{ position: 'absolute', zIndex: 2, width: width > 650 ? '600px' : '100%' }}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell>Reg No</StyledTableCell>
                                        <StyledTableCell>Customer</StyledTableCell>
                                        <StyledTableCell>VIN</StyledTableCell>
                                        <StyledTableCell>Branch</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {state.vehicleList.map((vehicle) => (
                                        <>
                                            <StyledTableRow key={vehicle.loanVehicleID} onClick={() => handleVehicleSelect(vehicle)} cursor="pointer">
                                                <StyledTableCell> {vehicle.reg || 'N/A'}</StyledTableCell>
                                                <StyledTableCell>{vehicle.customer || 'N/A'}</StyledTableCell>
                                                <StyledTableCell>{vehicle.vin || 'N/A'}</StyledTableCell>
                                                <StyledTableCell>{vehicle.branch || 'N/A'}</StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </ClickAwayListener>
            )}
        </Grid>
    );
};

export default SearchTcardByReg;
